<div class="container-box shadow-none">
  <div class="d-flex gap-3 align-items-center p-3">
    <img src="/assets/images/channel-wizards/listing-icon2.webp" alt="" height="40" />
    <div>
      <h6 class="mb-0" i18n>Rates</h6>
      <div class="text-sm">
        <ng-container i18n
          >As mentioned previously in this connection wizard, rates will now need to be pushed from AdvanceCM to
          Booking.com.</ng-container
        >
        <br />
        <ng-container i18n
          >Until this is done, your availability will remain blocked and the connection will not be
          complete.</ng-container
        >
      </div>
    </div>
  </div>
  <div class="border-top p-4 d-flex gap-5">
    <div class="flex-fill">
      <div class="alert alert-secondary-warning2" *ngIf="!isRentalRatesReady">
        <ng-container i18n>Your rental's rate information is incomplete:</ng-container>
        <ul class="mb-0 mt-1">
          <li *ngFor="let item of ratesMissing">{{ item }}</li>
        </ul>
        <div class="mt-1" *ngIf="autoPushState === 'missing'" i18n>
          Rates will be pushed to Booking.com automatically as soon as this is added.
        </div>
      </div>
      <div class="alert alert-secondary-info d-flex align-items-center gap-2" *ngIf="autoPushState === 'pushing'">
        <i class="far fa-spinner fa-spin"></i>
        <ng-container i18n>Pushing your AdvanceCM rates to Booking.com…</ng-container>
      </div>
      <div class="alert alert-secondary-success" *ngIf="autoPushState === 'done'">
        <ng-container i18n>Your rates were pushed to Booking.com automatically</ng-container>
        <ng-container *ngIf="autoPushedRateName"> ({{ autoPushedRateName }})</ng-container>.
        <ng-container i18n>You can review the sections below and push different rates at any time.</ng-container>
      </div>
      <div
        class="alert alert-secondary-warning2"
        *ngIf="(autoPushState === 'manual' || autoPushState === 'failed') && !isRatesPushed"
        i18n
      >
        Your rates could not be pushed automatically. Please review the sections below and use the Push Rates button to
        complete the connection.
      </div>
      <mat-accordion>
        <mat-expansion-panel [expanded]="true" #settings>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="step-number mr-2">1</div>
              <ng-container i18n>Add Rates</ng-container>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p i18n>
              As mentioned previously in this connection wizard, rates will now need to be pushed from AdvanceCM to
              Booking.com. Until this is done, your availability will remain blocked and the connection will not be
              complete.
            </p>

            <p i18n>
              If you have already prepared rates which you want to push to booking.com please hit Continue to proceed.
            </p>
            <div class="d-flex align-items-center gap-3">
              <button class="btn btn-light-info" (click)="onAddStandardRate()">
                <i class="far fa-plus"></i> <ng-container i18n>Add Standard Rate</ng-container>
              </button>
              <button class="btn btn-light-info" (click)="onAddDynamicRate()">
                <i class="far fa-plus"></i> <ng-container i18n>Add Dynamic Rate</ng-container>
              </button>
              <div class="flex-fill"></div>
              <button class="btn btn-light-info" (click)="pushRates.open()">
                <ng-container i18n>Next</ng-container> <i class="cs-icon cs-icon-arrow-down-long"></i>
              </button>
            </div>
          </div>
        </mat-expansion-panel>
        <mat-expansion-panel #pushRates>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="step-number mr-2">2</div>
              <ng-container i18n>Push Rates</ng-container>
              <i class="far fa-check-circle text-success ml-2" *ngIf="isRatesPushed"></i>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <p i18n>
              Your default rates are pushed to Booking.com's Standard rate plan automatically when you reach this step.
              This section lets you push different rates. After completing this step you should see both the
              availability and rates match with your booking.com rates calendar.
            </p>

            <p i18n>
              After clicking the Push Rates button you will be asked to specify the AdvanceCM Rate Category and the
              Channel Rate Category.
            </p>

            <p i18n>Here is a quick explanation of both values.</p>

            <div i18n class="text-semi-bold">AdvanceCM Rate Category:</div>
            <p i18n>
              This corresponds with the rate category you have created or selected when creating your rates in
              AdvanceCM.
            </p>

            <div i18n class="text-semi-bold">Channel Rate Category:</div>
            <p i18n>
              This corresponds with the rate name in Booking.com. By default the name of this rate will be Standard, but
              it is possible that you have renamed the standard rate in Booking.com and you will instead see that rate
              plan name as an option.
            </p>
            <div class="d-flex align-items-center gap-3">
              <button class="btn btn-light-info" (click)="onPushRates()">
                <i class="cs-icon cs-icon-upload"></i> <ng-container i18n>Push Rates</ng-container>
              </button>
              <div class="flex-fill"></div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
<div class="mt-3 d-flex align-items-center justify-content-between">
  <button class="btn btn-outline-light" (click)="prev.emit()">
    <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
    <ng-container i18n>Previous</ng-container>
  </button>
  <button class="btn btn-secondary-info" (click)="next.emit()">
    <ng-container i18n>Next</ng-container>
    <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
  </button>
</div>
